<div class="inicio">

    <div class="div">
      <p class="titulo">CATÁLOGO DE TIPOS DE EQUIPO</p>
      <mat-tab-group></mat-tab-group>

          <mat-tab-group   (selectedIndexChange)="capturarDatos($event)">
              <mat-tab label="Computadoras" > </mat-tab>
              <mat-tab label="Disp. de red" > </mat-tab>
              <mat-tab label="Impresoras">    </mat-tab>
              <mat-tab label="Monitores">     </mat-tab>
              <mat-tab label="Racks">         </mat-tab>
              <mat-tab label="Perifericos">   </mat-tab>
              <mat-tab label="Telefonos">     </mat-tab>
          </mat-tab-group>

      </div>
    <!--TABLA CON LOS DATOS -->
        <div class="div"  >

            <!--Barra de búsqueda-->
            <div  class="grid-container2">
                <mat-form-field>
                    <mat-label>BUSCAR</mat-label>
                    <input matInput  (keyup)="applyFilter($event)"  placeholder="INGRESE DATO A BUSCAR">
                </mat-form-field>

            </div>

            <!--Boton Descargar reporte-->
            <div class="grid-container5">
                <button mat-raised-button style="background-color: #28e702;" (click)="this.banderaFormulario=true" > AGREGAR TIPO
                    <mat-icon> playlist_add </mat-icon>
                </button>&nbsp;
            </div>
            <!--FORMULARIO PARA AGREGAR UN TIPO-->
            <div class="divAddTipo" *ngIf="this.banderaFormulario==true" >
              <form #insertForm="ngForm" [formGroup]="formTipo" >

                <div class="grid-container2"  >
                  <div class="celda"  >
                    <mat-label class="label">Categoría</mat-label>
                    <mat-form-field appearance="outline" >
                      <input matInput type="text"  formControlName="categoria"   />
                      <mat-label class="label">{{this.categoria}}</mat-label>
                    </mat-form-field>
                  </div>
                  <div class="celda" >
                    <mat-label class="label"> Tipo de equipo </mat-label>
                    <mat-form-field appearance="outline">
                      <input matInput type="text" placeholder="Ingresa el nuevo tipo de equipo"  formControlName="tipoEquipo"   oninput="this.value = this.value.toUpperCase()"/>
                    </mat-form-field>
                  </div>
                </div>
                <div class="grid-container" >
                  <div class="celda" >
                    <mat-label class="label"> Comentarios </mat-label>
                    <mat-form-field appearance="outline">
                      <input matInput type="text" placeholder="Comentarios"  formControlName="comentarios" oninput="this.value = this.value.toUpperCase()" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="wrapper">
                  <button mat-raised-button style="background-color: #00e760;" *ngIf="this.banderaEditar" (click)="editarTipo()" >Editar <span class="material-icons">edit</span> </button>
                  <button mat-raised-button style="background-color: #00e760;" *ngIf="this.banderaEditar==false" (click)="agregarTipoEquipo()" >Agregar <span class="material-icons">done</span> </button>
                  <br><br>
                  <button mat-raised-button style="background-color: #fd4545;" (click)="this.limpiarFormulario()" >Cancelar <mat-icon>cancel</mat-icon> </button>
                </div>
              </form>
            </div>

            <!--Tabla-->
            <table mat-table [dataSource] = "dataSource"  class="mat-elevation-z8">

                <!-- Position Column -->
                <ng-container matColumnDef="editar">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> EDITAR </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab style="background-color: #0804e9;" (click)="mostrarTipo(element.id)"> <span class="material-icons">edit</span> </button>
                    </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="categoria">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> CATEGORÍA </th>
                    <td mat-cell *matCellDef="let element"> {{this.categoria}} </td>
                </ng-container>
                <ng-container matColumnDef="tipoEquipo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO DE EQUIPO </th>
                  <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>
                <ng-container matColumnDef="comentarios">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> COMENTARIOS </th>
                  <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="fecha_creacion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE CREACIÓN </th>
                    <td mat-cell *matCellDef="let element"> {{element.date_creation.substring(0,10)}} </td>
                </ng-container>
                <ng-container matColumnDef="fecha_mod">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>FECHA DE MODIFICACIÓN </th>
                  <td mat-cell *matCellDef="let element"> {{element.date_mod.substring(0,10)}} </td>
              </ng-container>


                <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
                <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

            </table>
            <mat-paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>

      </div>



  </div>
